import { z } from 'zod';
const emptyToUndefined = z.preprocess((v) => (v === '' || v === null ? undefined : v), z.string().min(1).optional());
const emptyToNull = z.preprocess((v) => (v === undefined || v === null || v === '' ? null : v), z.union([z.string().min(1), z.null()]));
const boolish = z.preprocess((v) => {
    if (v === undefined || v === null || v === '')
        return false;
    if (typeof v === 'boolean')
        return v;
    if (typeof v === 'string')
        return v === 'true';
    return v;
}, z.boolean());
export const runtimeConfigSchema = z.object({
    apiUrl: z
        .string()
        .min(1)
        .refine((v) => /^https?:\/\//.test(v) || (v.startsWith('/') && !v.startsWith('//')), 'apiUrl must be an absolute http(s) URL or a single-slash same-origin path'),
    appUrl: z.string().url(),
    appEnv: z
        .enum(['development', 'preview', 'staging', 'production', 'test'])
        .default('production'),
    posthogKey: z.string().min(1),
    posthogHost: z.string().url(),
    sentryDsn: emptyToNull,
    sentryEnvironment: emptyToUndefined,
    marketingSentryDsn: emptyToNull,
    /**
     * Skip Sentry init on the WEB build of `apps/app`, leaving PostHog as the sole
     * error sink there. Native (iOS/Android via Capacitor) always initialises —
     * PostHog cannot see native crashes or ANRs, so Sentry is a permanent keep
     * there and this flag must never be able to turn it off.
     *
     * Named negatively ON PURPOSE. `boolish` treats unset/empty as `false`, so an
     * absent or misspelled env var leaves Sentry ON. A positively-named
     * `sentryWebEnabled` would fail the other way — one typo and web error
     * reporting silently disappears, which is precisely the class of bug this
     * whole PostHog migration exists to stamp out.
     */
    sentryWebDisabled: boolish,
    /**
     * Kill switch for the web build refresh (apps/app/src/lib/web-build-refresh.ts),
     * which moves an open tab onto a new deploy at the user's next page change.
     *
     * A runtime flag, not a build flag, ON PURPOSE: if the refresh misbehaves in
     * production, the fix cannot be "ship a change to the app" — a new app build
     * is the very event that triggers it. Set `WEB_BUILD_REFRESH_DISABLED=true`
     * on the host, then REDEPLOY: on Vercel an env var is fixed when a deployment
     * is created, so the running one keeps reporting `false` (observed). That
     * redeploy is safe — an unchanged app keeps its build id, so it triggers no
     * refresh. New tabs read the flag at boot; tabs already open re-read it the
     * moment they first see a newer build, before arming.
     *
     * Named negatively for the same reason as `sentryWebDisabled`: `boolish`
     * reads unset/empty/misspelled as `false`, so the safe default is "on".
     */
    webBuildRefreshDisabled: boolish,
    intercomAppId: emptyToNull,
    googleMapsApiKey: emptyToUndefined,
    stripePublishableKey: emptyToUndefined,
    metaAppId: emptyToUndefined,
    metaLoginConfigId: emptyToUndefined,
    whatsappEmbeddedSignupConfigId: emptyToUndefined,
    cdnUrl: emptyToUndefined,
    cdnEnabled: boolish,
    s3PublicAssetsBucket: emptyToUndefined,
    s3Region: emptyToUndefined,
});
//# sourceMappingURL=schema.js.map